import {
  FETCHING_MAP_PROJECTS,
  FETCHED_MAP_PROJECTS,
  FETCHED_MAP_PROJECTS_ERROR,
} from 'constants/actions';
import { combineReducers } from '@reduxjs/toolkit';

const isFetchingProjects = (state = false, action = {}) => {
  switch (action.type) {
    case FETCHING_MAP_PROJECTS:
      return true;

    case FETCHED_MAP_PROJECTS_ERROR:
    case FETCHED_MAP_PROJECTS:
      return false;

    default:
      return state;
  }
};

const hasError = (state = false, action = {}) => {
  switch (action.type) {
    case FETCHED_MAP_PROJECTS:
    case FETCHING_MAP_PROJECTS:
      return false;

    case FETCHED_MAP_PROJECTS_ERROR:
      return true;

    default:
      return state;
  }
};

// eslint-disable-next-line default-param-last
const error = (state = null, action) => {
  switch (action.type) {
    case FETCHED_MAP_PROJECTS:
    case FETCHING_MAP_PROJECTS:
      return null;

    case FETCHED_MAP_PROJECTS_ERROR:
      return action.payload;

    default:
      return state;
  }
};

const defaultPageData = {
  page: 0,
  totalPages: 0,
  totalCount: 0,
  count: 0,
};

const pagination = (state = defaultPageData, action = {}) => {
  switch (action.type) {
    case FETCHED_MAP_PROJECTS:
      return {
        page: action.payload.page,
        totalPages: action.payload.total_pages,
        totalCount: action.payload.total_count,
        count: action.payload.count,
      };

    default:
      return state;
  }
};

export default combineReducers({
  isFetchingProjects,
  hasError,
  error,
  pagination,
});
